import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import styles from "./SongPage.module.css";
import { buildApiUrl } from "../../config/api";

import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

import NotFound from "../NotFound/NotFound";
function SongPage() {
  const { id } = useParams();
  const [song, setSong] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSong() {
      try {
        const res = await axios.get(buildApiUrl(`/api/track/${id}`));
        setSong(res.data);
      } catch (err) {
        console.error("Fehler beim Laden des Songs", err);
      } finally {
        setLoading(false);
      }
    }
    fetchSong();
  }, [id]);

  if (song) {
      document.title = `${song.title} - ${song.interpret}`;
    }

   if (loading) {
    return (
      <div className={styles.wrapper}>
        <SkeletonTheme baseColor="var(--songpage-skeleton-base-color)" highlightColor="var(--songpage-skeleton-highlight-color)">
          <div className={`${styles.container} container`}>

            <div className={styles.content}>
              {/* Profilbild Skeleton */}
              <Skeleton height={200} width={200} />

              {/* Titel und Interpret */}
              <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                <Skeleton height={40} width={250} />
                <Skeleton height={30} width={180} style={{ marginTop: '0.5rem' }} />
              </div>


              {/* Anbieter Auswahl */}
              <p>
                <Skeleton height={24} width={163} />
              </p>

              {/* Buttons Skeleton */}
              <div className={styles.linkList}>
                {Array(6).fill(0).map((_, i) => (
                  <div key={i} className={styles.linkItem}>
                    <Skeleton height={24} width={90} />
                    <Skeleton height={24} width={90} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer bgColor="grey" />
        </SkeletonTheme>
      </div>
    );
  }

  if (!song) {
    return <NotFound />;
  }
  const baseUrl = window.location.origin;

  return (
    <>
    <Helmet>
      <title>{song.title} – alwinowitch</title>
      <meta
        name="description"
        content={`Höre ${song.title} von ${song.interpret} und entdecke mehr.`}
      />

      <meta property="og:title" content={`${song.title} – alwinowitch`} />
      <meta property="og:description" content={`Höre ${song.title} von ${song.interpret}.`} />
      <meta property="og:image" content={song.coverImageUrl} />
      <meta property="og:url" content={`${baseUrl}/song/${song.id}`} />
      <meta property="og:type" content="music.song" />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MusicRecording",
          "name": song.title,
          "byArtist": song.interpret,
          "url": `${baseUrl}/song/${song.id}`,
          "image": song.coverImageUrl
        })}
      </script>
    </Helmet>
    <div className={styles.wrapper}>
      <div className={`${styles.container} container`}>
      <div
        className={styles.background}
        style={{ backgroundImage: `url(${song.coverImageUrl})` }}
      ></div>

      <div className={styles.content}>
        <img src={song.coverImageUrl} alt={`${song.title} von ${song.interpret}`} className={styles.profileImg} />
        <h1>{song.title}</h1>
        <h2>{song.interpret}</h2>
        <p>Wähle Deinen Anbieter</p>

        <div className={styles.linkList}>
          {song.platforms.map((platform) => (
            <PlatformLink
              key={platform.type}
              platform={platform}
            />
          ))}
        </div>
      </div>
      </div>
      <Footer bgColor={"grey"}/>
    </div>
    </>
  );
}



function PlatformLink({ platform }) {
  const platformLogos = {
    SPOTIFY: "spotify-banner.png",
    YOUTUBE: "youtube-banner.png",
    SOUNDCLOUD: "soundcloud-banner.svg",
    APPLE: "applemusic-banner.png",
    YTMUSIC: "ytmusic-banner.svg",
    AMZNMUSIC: "amazonmusic-banner.png"
  };


  return (
    <div className={styles.linkItem}>
      <div className={styles.platform}>
        <img
          src={`/img/${platformLogos[platform.type]}`}
          alt={platform.type}
        />
        
      </div>
      <a href={platform.songUrl} target="_blank" rel="noopener noreferrer">
        <button
        className={styles.playbtn}
      >
        Abspielen
      </button>
      </a>
      
    </div>
  );
}

export default SongPage;
